/* eslint-disable */

import contextMakePost from './Context';
import domains from '../containers/Domains';
import { creds } from '../config/FBAdOps';

const endpoint = domains.fbEndpoint;

export const createEventSourceGroup = async (data, token) => {
  const parameters = {
    access_token: token,
    name: data.name,
    event_sources: [data.pixel]
  };

  const id = `${creds.appId}/event_source_groups`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const shareEventSourceGroupInAccount = async (data, token) => {
  const parameters = {
    access_token: token,
    accounts: data.accounts
  };

  const id = `${data.eventSourceGroup}/shared_accounts`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};



// WEBPACK FOOTER //
// ./src/fbApi/EventSourceGroup.js